import './not-found.scss';

import { t } from 'i18next';
import { FC } from 'react';

import error404 from './404.svg';

const NotFound: FC<any> = () => {
  return (
    <div className="wrapper">
      <div>
        <div className="heading-box">
          <h1>{t('pages.404.areYouLost?')}</h1>
        </div>
        <div className="img-error">
          <img className="resize" src={error404} />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
